import './QuickVehicleSpecItem.css'

export interface QuickVehicleSpecItemProps {
	id: string,
	title: string,
	value: string,
	onHover: (event: React.MouseEvent, value: string) => void,
	onLeave: () => void
}

export const QuickVehicleSpecItem = ({ id, title, value, onHover, onLeave }: QuickVehicleSpecItemProps) => {

	return (<>
		<div className="quick-vehicle-spec-item"
			onMouseEnter={(e) => onHover(e, value)}
			onMouseMove={(e) => onHover(e, value)}
			onMouseLeave={onLeave}
		>
			<div className='quick-vehicle-spec-item-title'>
				<img className='quick-vehicle-spec-item-icon' src={`./icons/32px/${id}.webp`}></img>
				<p>{title}</p>
			</div>

			<div className='quick-vehicle-spec-item-content'>
				<p>{value}</p>
			</div>

		</div>

	</>)
}
